export namespace ScreeningPackageStatusConstants {
  export const COMPLETE: string = 'Complete';
  export const ALERT: string = 'Alert';
  export const NEW: string = 'New';
  export const PENDING: string = 'Pending';
  export const PENDING_COLLECTION_SITE: string = 'Pending Facility Selection';
  export const REVIEW: string = 'Review';
  export const CANCELLED: string = 'Cancelled';
  export const ERROR: string = 'Error';
  export const EXPIRED: string = 'Expired';
  export const INVITE_EXPIRED: string = 'Invite Expired';
  export const UNKNOWN: string = 'Unknown';
  export const MISSING: string = 'Missing';
}
